import ContentTypeString from './content-type-string';
import './content-type-string.scss';

export default ContentTypeString;
